import React from 'react';
export function Disclaimer({ theme }: { theme: 'dark' | 'light' }) {
  return (
    <section className={`betterMood__disclaimer-${theme}`}>
      <p>
        Disclaimer: The information presented in Better Mood is for
        informational purposes only.
      </p>
      <p>&copy; 2025 Better Mood. All rights reserved</p>
    </section>
  );
}
